import type { MarketCode } from '../@types/Token';
import { getLanguage, getMarket, getMarketCode, getMarketMetadata } from './market';

export const currency = (number: string | number | null): string => {
  if (Number.isNaN(number)) return '';

  const market = getMarket();
  if (!market) return number!.toString();

  const { currencySymbol, currencySymbolBefore } = getMarketMetadata();
  return currencySymbolBefore ? `${currencySymbol} ${number}` : `${number} ${currencySymbol}`;
};

/**
 * Formats a number as currency with proper locale-aware formatting
 * @param amount - The amount to format
 * @param marketCode - Optional market code (defaults to current market)
 * @returns Formatted currency string (e.g., "10 000 kr" for SE, "10 000 kr" for NO)
 */
export const formatCurrency = (amount: number, marketCode?: MarketCode): string => {
  const market = marketCode || getMarketCode();
  const locale = getLanguage(market);
  const { currencySymbol } = getMarketMetadata();

  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);

  return `${formatted} ${currencySymbol}`;
};
